"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Message_1 = require("./Message");
var isMessageType = function (ctor) {
    return Object.prototype.isPrototypeOf.call(Message_1.default, ctor);
};
exports.MessageType = function (commandName) { return function (target) {
    if (!isMessageType(target)) {
        throw new Error('You need to extend the Message class to use the MessageType decorator');
    }
    target.COMMAND = commandName;
}; };
exports.MessageParamDefinition = function (spec) {
    if (spec === void 0) { spec = {}; }
    return function (target, propertyKey) {
        if (!(target instanceof Message_1.default)) {
            throw new Error('You need to extend the Message class to use the MessageParam decorator');
        }
        if (typeof propertyKey !== 'string') {
            return;
        }
        var cls = target.constructor;
        if (!cls.PARAM_SPEC) {
            cls.PARAM_SPEC = {};
        }
        cls.PARAM_SPEC[propertyKey] = spec;
    };
};
//# sourceMappingURL=MessageDefinition.js.map